import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api';

export interface KpiBonusSyncError {
  employee_id: string;
  employee_number?: string;
  error: string;
}

export interface KpiBonusSyncResponse {
  status: 'success' | 'partial' | 'failed';
  employees_processed: number;
  employees_with_bonuses: number;
  salary_rows_upserted: number;
  month_from: string;
  month_to: string;
  errors: KpiBonusSyncError[];
}

export interface KpiBonusSyncRequest {
  month_from?: string;
  month_to?: string;
  organization_ids?: string[];
  employee_ids?: string[];
}

/**
 * Trigger KPI bonus sync from kpi.sandyq.kz/tso/bonus into salary_data.
 * Empty body — uses default range (previous+current month) and the
 * per-organization allowlist (organizations.kpi_sync_enabled=true).
 */
export const useSyncKpiBonuses = () => {
  return useMutation({
    mutationFn: async (
      body: KpiBonusSyncRequest = {},
    ): Promise<KpiBonusSyncResponse> => {
      return apiClient.post('/api/v1/kpi-sync/bonuses', body);
    },
  });
};
